import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 0;

const slice = createSlice({
  name: '$averageAsapDeliveryTime',
  initialState,
  reducers: {
    setAverageAsapDeliveryTime(state, action: PayloadAction<number>) {
      return action.payload;
    },
  },
});

export const { setAverageAsapDeliveryTime } = slice.actions;
export default slice.reducer;
